import { useMemo } from 'react'
import { SPECIALS_REGISTRY } from '../specialsRegistry'
import type { SpecialContribution, SpecialContributorCtx } from '../specialsRegistry/types'

export function useObjectInfoCardSpecials(ctx: SpecialContributorCtx) {
    const contribs: SpecialContribution[] = SPECIALS_REGISTRY.map(c => c.useContribute(ctx))

    const computedFields = useMemo(() => Object.assign({}, ...contribs.map(c => c.computedFields ?? {})), [contribs])
    const extraButtonsBySection = useMemo(() => Object.assign({}, ...contribs.map(c => c.extraButtonsBySection ?? {})), [contribs])
    const buttonsOptions = useMemo(() => ({
        customActions: Object.assign({}, ...contribs.map(c => c.buttonsOptions?.customActions ?? {})),
    }), [contribs])

    return { computedFields, extraButtonsBySection, buttonsOptions }
}


